export const firebaseConfig = {
  apiKey: 'AIzaSyBBxfwtebF6It3DjZr5RSpjAH-Sw5JQUCg',
  authDomain: 'mydearsumone.firebaseapp.com',
  projectId: 'mydearsumone',
  storageBucket: 'mydearsumone.appspot.com',
  messagingSenderId: '652131303353',
  appId: '1:652131303353:web:c55649b39552435a6b0068',
  measurementId: 'G-F411V65WPZ',
}
